const LicenseTypeReport = () =>
  import(
    /* webpackChunkName: "base-info-courier-license-type" */ '@/pages/base-info/courier/license-type/index.vue'
  )
const CreateCourierLicenseType = () =>
  import(
    /* webpackChunkName: "base-info-courier-license-type" */ '@/pages/base-info/courier/license-type/create.vue'
  )
const EditCourierLicenseType = () =>
  import(
    /* webpackChunkName: "base-info-courier-license-type" */ '@/pages/base-info/courier/license-type/edit.vue'
  )

export default {
  path: 'license-type',
  meta: {
    label: 'courierLicenseType',
    auth: 'licenseType'
  },
  component: {
    name: 'LicenseType',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoCourierLicenseType',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: LicenseTypeReport
    },
    {
      name: 'BaseInfoCreateCourierLicenseType',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateCourierLicenseType
    },
    {
      name: 'BaseInfoEditCourierLicenseType',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditCourierLicenseType,
      props: true
    }
  ]
}
